export default __webpack_public_path__ + "static/Rockarrot-2e744c1be72ad31aeda03f9940b7667f.png";